<template>
  <LayoutDefault>
    <section class="paid-services">
      <h1 class="paid-services__title">Платные образовательные услуги</h1>
      <div class="paid-services__content"
        v-for="(item, idx) in services"
        :key="idx"
      >
        <div class="paid-services__editor" v-if="item.link == ''">
          <ckeditor
            :editor="editor"
            :config="editorConfig"
            :model-value="item.description"
          />
        </div>
        <div class="paid-services__documents" v-if="item.link !== ''">
          <p>{{ item.description }}</p>
          <span>{{ item.link }}</span>
        </div>
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
import { ref } from 'vue'
import LayoutDefault from '@/layout/LayoutDefault'

import Editor from 'ckeditor5-custom-build/build/ckeditor'

export default {
  name: 'PaidServicesView',
  components: {
    LayoutDefault
  },
  props: {
  },
  setup () {
    const editor = ref(Editor)

    const editorConfig = ref({})

    const services = ref([
      {
        id: 1,
        description: 'а) о порядке оказания платных образовательных услуг, в том числе образец договора об оказании платных образовательных услуг',
        link: ''
      },
      {
        id: 2,
        description: 'б) об утверждении стоимости обучения по каждой образовательной программе',
        link: ''
      },
      {
        id: 3,
        description: 'в) об установлении размера платы, взимаемой с родителей (законных представителей) за присмотр и уход за детьми, осваивающими образовательные программы дошкольного образования в организациях, осуществляющих образовательную деятельность, за содержание детей в образовательной организации, реализующей образовательные программы начального общего, основного общего или среднего общего образования, если в такой образовательной организации созданы условия для проживания обучающихся в интернате, либо за осуществление присмотра и ухода за детьми в группах продленного дня в образовательной организации, реализующей образовательные программы начального общего, основного общего или среднего общего образования. Программы для детей не реализуются',
        link: ''
      },
      {
        id: 4,
        description: 'Положение об оказании платных образовательных услуг',
        link: 'Pologhenie_ob_platnyh_uslugag.pdf'
      },
      {
        id: 5,
        description: 'Образец договора об оказании платных образовательных услуг',
        link: 'Obrazec_dogovora4.doc'
      },
      {
        id: 6,
        description: 'Приказ о стоимости обучения',
        link: 'Prikaz_o_stoimosti.pdf'
      }
    ])

    return {
      editor,
      editorConfig,
      services
    }
  }
}
</script>

<style lang="scss" scoped>
.paid-services {
  &__title {
    @include information-block-title;
    margin-bottom: 24px;
  }

  &__content {
    text-align: left;
  }

  &__content:nth-child(4) {
    margin-bottom: 32px;
  }

  &__editor {
    width: 40%;
    margin-bottom: 24px;
  }

  &__documents {
    display: flex;
    gap: 16px;
    width: 45%;
    margin-bottom: 24px;

    p {
      flex-basis: 45%;
      flex-grow: 1;
      font-size: 14px;
      line-height: 18px;
    }

    span {
      flex-basis: 55%;
      color: #1BA6DA;
      cursor: pointer;
    }
  }
}
</style>
